import React from "react";
import Button from "@material-ui/core/Button";
import {font_style} from "../styles"

const style = {
    color: '#F2F2F2',
    light: '#0066ff',
    contrastText: '#616161',
    fontFamily:"Open Sans Hebrew"
};

function RectangularButton(props) {
    function handleClick(){
        window.location.assign(props.link);
    }

    return(
        <Button
            style = {font_style}
            type="button"
            fullWidth
            variant="contained"
            onClick={handleClick}
        >
            {props.text}
        </Button>
    );
}
export default RectangularButton


